module.exports = __webpack_public_path__ + "static/media/cloud-island-bg-noclouds.d69068e2.svg";